module.exports = __webpack_public_path__ + "static/media/match.6849ee1d.svg";